module.exports = __webpack_public_path__ + "img/arrow-left.2b303948.svg";